import React from 'react';
import { AlertCircle } from 'lucide-react';

const BinCapacityError = ({ response }) => {
  // Extract data from the new response structure
  const details = response?.details || {};
  const bins = (details.problematicBins || []).sort((a, b) => {
    return a.binCode.localeCompare(b.binCode, undefined, { numeric: true, sensitivity: 'base' });
  });
  const capacity = details.proposedCapacity;

  return (
    <div style={{ padding: '1rem', maxWidth: '600px', margin: '0 auto' }}>
      {/* Error Header */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        marginBottom: '1rem',
        padding: '10px',
        backgroundColor: '#fef2f2',
        borderRadius: '8px',
        border: '1px solid #fecaca'
      }}>
        <AlertCircle size={24} color="#dc2626" />
        <div>
          <h3 style={{ margin: 0, color: '#dc2626', fontSize: '16px', fontWeight: '600' }}>
            Cannot Set Max Capacity to {capacity}
          </h3>
          {bins.length > 0 &&
          <p style={{ margin: 0, color: '#991b1b', fontSize: '12px' }}>
            The following bins exceed this capacity limit
          </p>
          }
        </div>
      </div>

      {/* Bins Table */}
      { bins.length > 0 &&
      <div style={{
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '370px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '1rem'
      }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          backgroundColor: 'white'
        }}>
          <thead>
            <tr style={{ backgroundColor: '#f9fafb' }}>
              <th style={{
                padding: '0.5rem',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '0.875rem',
                color: '#374151',
                borderBottom: '1px solid #e5e7eb'
              }}>
                #
              </th>
              <th style={{
                padding: '0.5rem',
                textAlign: 'left',
                fontWeight: '600',
                fontSize: '0.875rem',
                color: '#374151',
                borderBottom: '1px solid #e5e7eb'
              }}>
                Bin Code
              </th>
              <th style={{
                padding: '0.5rem',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '0.875rem',
                color: '#374151',
                borderBottom: '1px solid #e5e7eb'
              }}>
                Current Quantity
              </th>
                 <th style={{
                padding: '0.5rem',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '0.875rem',
                color: '#374151',
                borderBottom: '1px solid #e5e7eb'
              }}>
                Proposed Capacity
              </th>
              <th style={{
                padding: '0.5rem',
                textAlign: 'center',
                fontWeight: '600',
                fontSize: '0.875rem',
                color: '#374151',
                borderBottom: '1px solid #e5e7eb'
              }}>
                Excess Items
              </th>
            </tr>
          </thead>
          <tbody>
            {bins.map((bin, index) => (
              <tr key={bin.binId} style={{
                borderBottom: index < bins.length - 1 ? '1px solid #e5e7eb' : 'none'
              }}>
                <td style={{
                  padding: '0.75rem',
                  textAlign: 'center',
                  fontSize: '0.875rem',
                  color: '#6b7280'
                }}>
                  {index + 1}
                </td>
                <td style={{
                  padding: '0.75rem',
                  fontSize: '0.875rem',
                  textAlign: 'left',
                  color: '#111827',
                  fontWeight: '500'
                }}>
                  {bin.binCode}
                </td>
                <td style={{
                  padding: '0.75rem',
                  textAlign: 'center',
                  fontSize: '0.875rem',
                  color: '#111827',
                  fontWeight: '600'
                }}>
                  {bin.currentQuantity} {bin.currentQuantity === 1 ? 'item' : 'items'}
                </td>
                  <td style={{
                  padding: '0.75rem',
                  textAlign: 'center',
                  fontSize: '0.875rem',
                  color: '#111827',
                  fontWeight: '600'
                }}>
                  {bin.proposedCapacity} {bin.proposedCapacity === 1 ? 'item' : 'items'}
                </td>
                <td style={{
                  padding: '0.75rem',
                  textAlign: 'center',
                  fontSize: '0.875rem'
                }}>
                  <span style={{
                    backgroundColor: '#fee2e2',
                    color: '#991b1b',
                    padding: '0.25rem 0.5rem',
                    borderRadius: '4px',
                    fontWeight: '600'
                  }}>
                    +{bin.currentQuantity - bin.proposedCapacity}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      }
      {/* Action Message */}
      {bins.length > 0 &&
      <div style={{
        padding: '8px 15px',
        backgroundColor: '#fffbeb',
        borderRadius: '8px',
        border: '1px solid #fde68a'
      }}>
        <p style={{
          margin: 0,
          color: '#92400e',
          fontSize: '0.8rem',
          lineHeight: '1.5'
        }}>
          ⚠️ <strong>Action Required:</strong> <br /> Please remove items from these bins first, or set a higher capacity.
        </p>
      </div>
       }
       {/* Error message of no bins found */}
       {bins.length === 0 &&
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '1.5rem',
          backgroundColor: '#fef2f2',
          borderRadius: '8px',
          border: '1px solid #fecaca',
          textAlign: 'center',
          flexDirection: 'column'
        }}>
          <AlertCircle size={48} color="#dc2626" />
          <div>
            <h3 style={{ margin: '0 0 0.5rem 0', color: '#dc2626', fontSize: '18px', fontWeight: '600' }}>
              Something went wrong
            </h3>
            <p style={{ margin: 0, color: '#991b1b', fontSize: '14px' }}>
              Please try again
            </p>
          </div>
        </div>
      </div>
       }
    </div>
  );
};

export default BinCapacityError;